import React from 'react';
import { connect } from "react-redux";
import {
    CardBody,
    Col, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import {FL_BADWORD} from "../../../components/i18n/formLabels";
import {PH_SEARCH_WORD} from "../../../components/i18n/placeHolders";
import {setFilter} from "../../../redux/actions/generalActions/listActions";


const BadWordFilter = (props) => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const fbDataBaseId = app?.fbDataBase?.id

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        reset({
            word: '',
        });
        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.word;
        }
        props.setFilter(tmpFilter);
    }

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            word: filter?.item?.word,
        }
    });

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            item : {
                word: data.word
            }
        }

        props.setFilter(dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_BADWORD }</Label>
                            <Input type="text" name="word"
                                   placeholder={ PH_SEARCH_WORD }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4" className="d-flex align-items-center">
                        <div >
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(BadWordFilter)